import { GetRemindChannelSet , SetRemindChannel, renew, saveMuteSet } from '@/api/MessageSwitch';

const state = {
  GetRemindChannelSet : {},

  // 记录人工协助的位置
  xPumValue: '0', 
  yPumValue: '0',
  //优惠券按钮位置
  xPumValue01: '0',
  yPumValue01: '0',
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  },
  CHANGE_DATA: (state,{key,data})=>{
    state.GetRemindChannelSet[key] = data
  },
};
const actions = {
  GetRemindChannelSet({ commit },data) { // 消息接收渠道
    return new Promise((resolve)=>{
      GetRemindChannelSet(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'GetRemindChannelSet',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      });
    })
  },
  SetRemindChannel({ commit },data) { // 设置消息接收渠道
    return new Promise((resolve)=>{
      SetRemindChannel(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'SetRemindChannel',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      });
    })
  },
  renew({ commit },data) { // '立即续费'弹窗判断
    return new Promise((resolve)=>{
      renew(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'renew',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      });
    })
  },
  saveMuteSet({ commit },data) { // 设置免打扰时间
    return new Promise((resolve)=>{
      saveMuteSet(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'saveMuteSet',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      });
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
